<div>
  <div class="pt-5">
    <div class="mb-5 flex overflow-y-auto whitespace-nowrap border-b border-[#ebedf2] font-semibold dark:border-[#191e3a]">
      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'settings',
        }"
        (click)="activeTab = 'settings'"
      >
        <icon-user class="h-5 w-5" />
        {{ "user_profile.profile" | translate }}
      </a>
      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'picklist',
        }"
        (click)="activeTab = 'picklist'"
      >
        <icon-dollar-sign-circle class="h-5 w-5" />
        {{ "user_profile.picklists" | translate }}
      </a>
      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'agency',
        }"
        (click)="activeTab = 'agency'"
      >
        <!-- Icon representing Agency (similar to business/office) -->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-5 w-5">
          <rect x="2" y="2" width="20" height="20" rx="2" ry="2" />
          <path d="M7 21v-4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4" />
          <path d="M8 7h8" />
          <path d="M8 11h8" />
        </svg>
        {{ "user_profile.agency_tab" | translate }}
      </a>
      <a
        href="javascript:;"
        class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-primary hover:text-primary"
        [ngClass]="{
          '!border-primary text-primary': activeTab.toLowerCase() === 'tax-rate-categories',
        }"
        (click)="activeTab = 'tax-rate-categories'"
      >
        <icon-tag class="h-5 w-5" />
        {{ "user_profile.tax_rate_categories_tab" | translate }}
      </a>
    </div>

    <div *ngIf="activeTab.toLowerCase() === 'picklist'">
      <app-picklist></app-picklist>
    </div>
    <div *ngIf="activeTab.toLowerCase() === 'agency'">
      <app-agency-profile></app-agency-profile>
    </div>
    <div *ngIf="activeTab.toLowerCase() === 'tax-rate-categories'">
      <app-configuration-tax-rate-categories></app-configuration-tax-rate-categories>
    </div>
    <div>
      <div *ngIf="activeTab.toLowerCase() === 'settings'">
        <form [formGroup]="userSettingsForm" class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]">
          <h6 class="mb-5 text-lg font-bold">{{ "user_profile.user_info" | translate }}</h6>
          <div class="flex flex-col sm:flex-row">
            <div class="mb-5 w-full sm:w-2/12 ltr:sm:mr-4 rtl:sm:ml-4">
              <img src="/assets//images/avatardefault.jpg" alt="" class="mx-auto h-20 w-20 rounded-full object-cover md:h-32 md:w-32" />
            </div>
            <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
              <div [class.has-error]="!userSettingsForm.get('name')?.valid && userSettingsForm.get('name')?.touched">
                <label class="form-label" for="name">{{ "user_profile.name" | translate }}</label>
                <input
                  id="name"
                  type="text"
                  [ngClass]="!editProfile ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
                  [placeholder]="'user_profile.enter_name' | translate"
                  class="form-input"
                  formControlName="name"
                />
              </div>
              <div [class.has-error]="!userSettingsForm.get('surname')?.valid && userSettingsForm.get('surname')?.touched">
                <label class="form-label" for="surname">{{ "user_profile.surname" | translate }}</label>
                <input
                  id="surname"
                  type="text"
                  [ngClass]="!editProfile ? 'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]' : 'form-input'"
                  [placeholder]="'user_profile.enter_surname' | translate"
                  class="form-input"
                  formControlName="surname"
                />
              </div>

              <div [class.has-error]="!userSettingsForm.get('role')?.valid && userSettingsForm.get('role')?.touched">
                <label class="form-label" for="role">{{ "user_profile.role" | translate }}</label>
                <input
                  id="role"
                  type="text"
                  [ngClass]="'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]'"
                  [placeholder]="'user_profile.enter_role' | translate"
                  class="form-input"
                  formControlName="role"
                />
              </div>
              <div [class.has-error]="!userSettingsForm.get('email')?.valid && userSettingsForm.get('email')?.touched">
                <label class="form-label" for="email">{{ "user_profile.email" | translate }}</label>
                <input
                  id="email"
                  type="email"
                  [ngClass]="'form-input cursor-not-allowed disabled:pointer-events-none disabled:bg-[#eee] dark:disabled:bg-[#1b2e4b]'"
                  [placeholder]="'user_profile.enter_email' | translate"
                  class="form-input"
                  formControlName="email"
                />
              </div>

              <div class="mt-3 sm:col-span-1">
                <div class="flex">
                  <button *ngIf="editProfile" type="button" class="btn btn-primary mr-2" (click)="updateUser()" [disabled]="isLoading">
                    <ng-container *ngIf="isLoading; else alternateTranslation">
                      <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
                      {{ "loading" | translate }}
                    </ng-container>
                    <ng-template #alternateTranslation>
                      <span>{{ "user_profile.save" | translate }}</span>
                    </ng-template>
                  </button>
                  <button *ngIf="editProfile" type="button" class="btn btn-danger" (click)="discardChanges()">
                    {{ "user_profile.discard" | translate }}
                  </button>
                </div>
                <button *ngIf="!editProfile" type="button" class="btn btn-primary" (click)="editUser()">
                  {{ "user_profile.edit" | translate }}
                </button>
              </div>
              <div class="mt-3 sm:col-span-1">
                <button type="button" class="btn btn-primary" (click)="openPasswordModal()">
                  {{ "user_profile.change_password" | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #modalTemplate>
  <div class="flex flex-col p-4">
    <div class="!py-5"></div>
    <app-user-new-password [email]="email" (notifyWhenSend)="passwordUpdated($event)"></app-user-new-password>
  </div>
</ng-template>
